import { render, staticRenderFns } from "./Trophy.vue?vue&type=template&id=18f99fd4&scoped=true&"
import script from "./Trophy.vue?vue&type=script&lang=js&"
export * from "./Trophy.vue?vue&type=script&lang=js&"
import style0 from "./Trophy.vue?vue&type=style&index=0&id=18f99fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f99fd4",
  null
  
)

export default component.exports